import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth } from '../lib/api';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('finscope_token');
    const savedUser = localStorage.getItem('finscope_user');
    
    if (token && savedUser) {
      setUser(JSON.parse(savedUser));
      // Verify token is still valid
      auth.me()
        .then((res) => {
          setUser(res.data);
          localStorage.setItem('finscope_user', JSON.stringify(res.data));
        })
        .catch(() => {
          logout();
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const response = await auth.login({ email, password });
    const { access_token, user: userData } = response.data;
    
    // Clear any previous marca context (important for Super Admin)
    localStorage.removeItem('selectedMarcaId');
    localStorage.removeItem('selectedMarcaNombre');
    localStorage.removeItem('selectedClienteId');
    localStorage.removeItem('selectedClienteNombre');
    
    localStorage.setItem('finscope_token', access_token);
    localStorage.setItem('finscope_user', JSON.stringify(userData));
    setUser(userData);
    
    return userData;
  };

  const register = async (data) => {
    const response = await auth.register(data);
    const { access_token, user: userData } = response.data;
    
    localStorage.setItem('finscope_token', access_token);
    localStorage.setItem('finscope_user', JSON.stringify(userData));
    setUser(userData);
    
    return userData;
  };

  const logout = () => {
    localStorage.removeItem('finscope_token');
    localStorage.removeItem('finscope_user');
    // Clear marca context
    localStorage.removeItem('selectedMarcaId');
    localStorage.removeItem('selectedMarcaNombre');
    localStorage.removeItem('selectedClienteId');
    localStorage.removeItem('selectedClienteNombre');
    setUser(null);
  };

  const isAdmin = user?.role === 'admin_cliente' || user?.role === 'super_admin' || user?.role === 'admin';
  const isSuperAdmin = user?.role === 'super_admin';

  return (
    <AuthContext.Provider value={{ 
      user, 
      login, 
      register, 
      logout, 
      loading,
      isAdmin,
      isSuperAdmin
    }}>
      {children}
    </AuthContext.Provider>
  );
};
